export const FILM_STATUS_PENDING = 'pending';
export const FILM_STATUS_PROCESSED = 'processed';
export const FILM_STATUS_REJECTED = 'rejected';
export const FILM_STATUS_PUBLISHED = 'published';
export const FILM_STATUS_APPROVED = 'approved';


// WEBPACK FOOTER //
// ./src/constants/amateurFilms.js